<template>
  <div id="app">
    <link rel="prefetch" v-for="asset in Object.values($assets)" :key="asset" :href="asset" />
    <div id="banner-container" :class="{'home-banner': $route.name === 'home'}">
      <div id="banner-content">
        <div class="banner-left">
          <router-link :to="{name: 'home'}">
            <font-awesome-icon icon="ring"/>
            home
          </router-link>
          <router-link to="/registry">
            <font-awesome-icon icon="gift"/>
            registry
          </router-link>
        </div>
        <div class="banner-center">
          <span>Kit</span>
          <span> &amp; </span>
          <span>Mariette</span>
        </div>
        <div class="banner-right">
          <router-link to="/wedding">
            <font-awesome-icon icon="glass-cheers"/>
            wedding
          </router-link>
          <a href="https://photos.app.goo.gl/xhu1q7bz2wkt6PRi9">
            <font-awesome-icon icon="images"/>
            gallery
          </a>
        </div>
      </div>
    </div>
    <div class="main-view">
      <transition>
        <router-view/>
      </transition>
    </div>
    <div class="footer">
      <p>
        This site was lovingly crafted by Kit. He would appreciate any
        <a href="https://www.youtube.com/watch?v=zi8ShAosqzI">compliments</a> you have about it.
      </p>
    </div>
  </div>
</template>


<script>
  export default {
  }
</script>

<style lang="scss" scoped>
  .footer {
    color: var(--text-color-unpop);
    font-size: 90%;
    margin-top: 4em;
  }

  .v-enter-active, .v-leave-active {
    transition: all .2s;
    overflow: hidden;
    width:100%;
    height: 100%;
  }

  .v-enter, .v-leave-to {
    opacity: 0;
  }

  .v-leave, .v-enter-to {
    opacity: 1;
  }
</style>

<style lang="scss">
  @import url('https://fonts.googleapis.com/css?family=Crimson+Text&display=swap');

  body, html {
    --text-hue: 210;
    --text-color-main: hsl(var(--text-hue), 29%, 24%);
    --text-color-unpop: hsl(var(--text-hue), 10%, 50%);
    height: 100%;
    padding: 0;
    margin: 0;
  }

  * {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-rendering: optimizeLegibility;
    //text-shadow: rgba(0, 0, 0, .1) 0 0 1px;
  }


  a {
    text-decoration: none;
    color: hsl(var(--text-hue), 50%, 50%);
    &:visited {
      color: hsl(var(--text-hue), 40%, 70%);
    }
  }

  #app {
    font-family: 'Crimson Text', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: var(--text-color-main);
    min-height: 100%;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    padding: 0;
    margin: 0;
  }

  .main-view {
    max-width: 60em;
    width: 100%;
    margin: 0 auto;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
  }

  #banner-container {
    z-index: 1000;
    background-color: white;
    position: sticky;
    top: 0;
    box-sizing: border-box;
    margin: 1em auto 4em;
    width: 100%;


    .banner-center {
      span {
        width: fit-content;

        &:first-child, &:last-child {
          font-size: 200%;
        }

        &:nth-child(2) {
          padding-bottom: 0.1em;
        }
      }
      white-space: nowrap;
      @media (max-width: 388px){
        white-space: normal;
      }
    }

  }

  #banner-content {
    padding: 1em 1.5em 1em;
    width: 100%;
    max-width: 60em;
    margin: auto;
    display: grid;
    grid-template-columns: 25% 50% 25%;
    box-sizing: border-box;
    justify-content: space-between;
    align-items: flex-end;

    .banner-left, .banner-right {
      display: flex;
      flex-wrap: wrap;

      a {
        outline: 0;
        white-space: nowrap;
        text-decoration: none;
        color: var(--text-color-unpop);

        &:active, &:hover, &:focus, &.router-link-exact-active {
          color: darken(white, 80%);
        }

        img, svg {
          width: 1em;
        }

        svg {
          display: inline-block;
          font-size: 69%;
        }
      }
    }

    .banner-left {
      a {
        padding-right: 1em;
      }
    }

    .banner-right {
      justify-content: flex-end;

      a {
        padding-left: 1em;
      }
    }

  }

  #banner-container.home-banner {
    background-color: unset;
    color: white;

    #banner-content {
      a {
        color: white;

        &:active, &:hover, &:focus, &.router-link-exact-active {
          color: white;

          path.flag-dark {
            fill: white;
          }
        }

        img, svg {
          width: 1em;
        }

        svg {
          display: inline-block;
          font-size: 69%;
        }
      }
    }
  }

  .button-group {
    button, div {
      border-radius: 0;
      margin-left: 0;
      margin-right: -1px;

      &:first-child {
        border-bottom-left-radius: 4px;
        border-top-left-radius: 4px;
      }

      &:last-child {
        border-bottom-right-radius: 4px;
        border-top-right-radius: 4px;
      }
    }
  }

  .pop {
    font-size: 120%;
    font-weight: 500;
  }

  .unpop {
    color: var(--text-color-unpop);
  }

  .cascade-flex-grow {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
  }

</style>
